export default __webpack_public_path__ + "static/media/4.0c1ccf4c.png";